import React from "react";
import { HowToBuyTrxContainer } from "./HowToBuyTrx.styled";
import img1 from '../../assets/Screenshot_20230403-101130_Chrome 1.png'
import img2 from '../../assets/Screenshot_20230402_042848_Samsung Internet 1.png'
import img3 from '../../assets/Screenshot_20230403-102419_Chrome 1 (1).png'
import img4 from '../../assets/Screenshot_20230403-102159_Chrome 1.png'

const HowToBuyTrx = () => {
  return (
    <HowToBuyTrxContainer>
      <p>
        Sign up for an account on a cryptocurrency exchange that supports TRX.
        Some popular options include Binance, Coinbase, and Kraken.
      </p>

      <p>
        Verify your account by providing the required information and completing
        any necessary KYC (know your customer) procedures.
      </p>

      <p>
        Once your account is verified, you'll need to deposit funds to buy TRX.
        Most exchanges support a variety of payment methods, including bank
        transfers, credit/debit cards, and cryptocurrencies.
      </p>

      <p>
        After your deposit has been credited to your account, search for TRX on
        the exchange's trading platform.
      </p>

      <p>
        You can buy TRX with other cryptocurrencies, like Bitcoin or Ethereum,
        or with fiat currency, like USD or EUR.
      </p>

      <p>
        Enter the amount of TRX you want to buy and review the transaction
        details, including the current price and any fees involved.
      </p>

      <p>
        If everything looks good, confirm the purchase, and the TRX will be
        credited to your exchange account.
      </p>

      <p>
        Alternatively, you can also buy TRX on peer-to-peer marketplaces like
        LocalTron or through decentralized exchanges like Uniswap.
      </p>

      <p>
        It's important to note that the process of buying TRX may vary slightly
        depending on the exchange or marketplace you choose to use. Be sure to
        review the platform's guidelines and procedures before making any
        purchases. Listed below is a image guide on how to go about it.
      </p>
      {[
        {
            name: "Binance",
            link: "https://www.binance.com/en/how-to-buy/tron",
            image: img1,
        },
        {
            name: "Ledger",
            link: "https://www.ledger.com/buy/tron#:~:text=You%20can%20buy%20Tron%20via,able%20to%20start%20buying%20Tron",
            image: img2,
        },
        {
            name: "Coinbase",
            link: "https://www.coinbase.com/how-to-buy/tron",
            image: img3,
          },
          {
            name: "Kraken",
            link: "https://www.kraken.com/en-gb/learn/buy-tron-trx",
            image: img4,
        }
      ].map((data, index) => <div key={index} style={{display: "flex", flexDirection: "column"}}>
        <h3>{data.name}</h3>
        <a href={data.link} target="_blank" rel="noreferrer">Click here to Buy With {data.name}</a>
        <img src={data.image} alt={data.name} style={{margin: "10px auto"}} />
      </div>)}
    </HowToBuyTrxContainer>
  );
};

export default HowToBuyTrx;
